import styled from '../themes/styled'
import { RadioButtonSize, sizeMap } from './index'
import Radio, { RadioProps } from '@mui/material/Radio'
import { TextScale } from 'particles/Text'

interface StyledRadioButtonProps {
    textScale: TextScale
    iconSize: RadioButtonSize
    containerHeight: number | undefined
}

export const StyledRadioButtonContainer = styled.div<StyledRadioButtonProps>`
    display: flex;
    flex-direction: row;
    ${({ theme, containerHeight, textScale }) => ({
        gap: theme.spacing[100],
        alignItems:
            containerHeight && containerHeight >= Number(theme.textScale[textScale].lineHeight.split('px')[0]) * 2
                ? 'start'
                : 'center',
    })}
    .radio-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: ${({ iconSize }) => sizeMap[iconSize].outlineSize};
        width: ${({ iconSize }) => sizeMap[iconSize].outlineSize};
    }
    .radio {
        padding: 0;
    }
    .radio-icon {
        overflow: visible;
        ${({ theme }) => ({
            color: theme.colors.icon.primary,
        })}
    }
    .label {
        white-space: pre-wrap;
    }
`

interface NoSelectedContainerProps {
    size: RadioButtonSize
}

export const StyledNoSelectedContainer = styled.div<NoSelectedContainerProps>`
    display: inline-flex;
    height: ${({ size }) => sizeMap[size].outlineSize};
    padding: 0px 12px 0px 11px;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[200]};
    flex-shrink: 0;
    border-radius: 4px;
    border-left: 1px solid ${({ theme }) => theme.colors.border.disable};
`

interface StyledRadioProps extends RadioProps {
    iconSize: RadioButtonSize
}

export const StyledRadio = styled(Radio)<StyledRadioProps>(({ iconSize, disabled, theme }) => ({
    '&.MuiRadio-root': {
        color: theme.colors.text.primary,
        '&.Mui-disabled': {
            color: theme.colors.surface.disable,
        },
        '&.Mui-checked': {
            color: disabled ? theme.colors.surface.disable : theme.colors.surface.action,
        },
        '&.Mui-focusVisible': {
            width: sizeMap[iconSize].outlineSize,
            height: sizeMap[iconSize].outlineSize,
            boxSizing: 'border-box',
            borderRadius: '4px',
            border: `2px solid ${theme.colors.border.actionFocus}`,
        },
    },
    '& .MuiSvgIcon-root': {
        fontSize: sizeMap[iconSize].iconSize,
    },
}))
